import { toast, ToastContainer } from 'react-toastify';
import { FaCheckCircle, FaExclamationCircle, FaInfoCircle, FaRegDotCircle } from 'react-icons/fa';

const showToast = (type, message, options = {}) => {
  switch (type) {
    case 'success':
      toast.success(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "#ECFDF5",
          color: '#166534',
          borderRadius: '8px',
          padding: '10px',
          fontFamily: 'Inter',
        },
        progressClassName: 'bg-emerald-500',
        toastClassName: 'border-l-4 border-emerald-500 shadow-lg',
        icon: <FaCheckCircle size={20} className="text-emerald-500" />, 
        ...options,
      });
      break;
    case 'error':
      toast.error(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white",
          color: '#DA1A28',
          borderRadius: '8px',
          padding: '10px',
          fontFamily: 'Inter',
        },
        progressClassName: 'bg-[#DA1A28]',
        toastClassName: 'border-l-4 border-[#DA1A28] shadow-lg',
        icon: <FaExclamationCircle size={20} className="text-[#DA1A28]" />, 
        ...options,
      });
      break;
    case 'info':
      toast.info(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white",
          color: '#0020BD',
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#0020BD]',
        toastClassName: 'border-l-4 border-[#0020BD] shadow-lg',
        icon: <FaInfoCircle size={20} className="text-[#0020BD]" />, 
        ...options,
      });
      break;
    case 'warning':
      toast.warning(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white",
          color: '#DA1A28',
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#DA1A28]',
        toastClassName: 'border-l-4 border-[#DA1A28] shadow-lg',
        icon: <FaRegDotCircle size={20} className="text-[#DA1A28]" />, 
        ...options,
      });
      break;
    default:
      toast(message, {
        style: {
          fontSize: '14px',
          backgroundColor: "white",
          color: "#060073",
          borderRadius: '8px',
          padding: '10px',
        },
        progressClassName: 'bg-[#0020BD]',
        toastClassName: 'border-l-4 border-[#060073] shadow-lg',
        icon: <FaInfoCircle size={20} className="text-[#060073]" />, 
        ...options,
      });
      break;
  }
};

export default showToast;
